import { useEffect, useState } from 'react';
import './App.css';
import Ludograph from './Ludograph/Ludograph';
import TableTopPage from './TableTopPage/TableTopPage';

const currentRoute = () => window.location.hash.replace(/^#/, '').split('?')[0];

function App() {
  const [route, setRoute] = useState(currentRoute);

  useEffect(() => {
    const onHashChange = () => setRoute(currentRoute());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  return (
    <div className="App">
      {route === '/ludograph' ? <Ludograph /> : <TableTopPage></TableTopPage>}
    </div>
  );
}

export default App;
